import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

const stats = [
    { value: "2017", label: "Founded and operating" },
    { value: "Nigeria", label: "Serving multiple states across Nigeria" },
    { value: "FMCG", label: "Grade hygiene standards, audit-tested" },
    { value: "Daily", label: "Supervisor checks and sign-offs" },
];

export default function StatsBand() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

    return (
        <section ref={ref} className="relative overflow-hidden bg-forest" data-testid="stats-band">
            <motion.img
                src="https://images.pexels.com/photos/3747070/pexels-photo-3747070.jpeg?auto=compress&cs=tinysrgb&w=2000"
                alt=""
                aria-hidden="true"
                style={{ y, scale: 1.25 }}
                className="absolute inset-0 w-full h-full object-cover opacity-15"
            />
            <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
                {stats.map((s, i) => (
                    <motion.div
                        key={s.label}
                        data-testid={`stat-${i}`}
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
                    >
                        <p className="font-serif text-5xl md:text-6xl font-medium text-background leading-none mb-3">
                            {s.value}
                        </p>
                        <p className="text-xs font-bold tracking-[0.2em] uppercase text-sage">{s.label}</p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
